export const ignoredRoutes = [
    '/login',
    '/onboarding',
    '/two-factor-select',
    '/two-factor-verify',
    '/reset-password',
    '/dominio-beneficios',
    '/dominio-beneficios-pat',
    '/beneficios/secure-card-viewer',
];
